import React from 'react';

import NextImage from 'next/image';

import { Container } from '../../../../components/Container/Container';
import { Heading } from '../../../../components/Heading/Heading';
import { CheckFillCircleIcon } from '../../../../components/Icons/CheckFillCircleIcon';
import { Text } from '../../../../components/Text/Text';
import format from '../../assets/format.png';

import styles from './AdvertiseformatSection.module.css';

export const AdvertiseformatSection = () => {
  return (
    <section
      className="col-start-1 row-start-4 grid grid-cols-1 grid-rows-1"
      data-testid="AdvertiseFormatSection"
    >
      <div className="grid grid-cols-1 grid-rows-1">
        {/* Background */}
        <div className="col-start-1 row-start-1 grid size-full grid-cols-1 grid-rows-1">
          <div
            className={`mb-px size-full bg-cover bg-center bg-no-repeat ${styles.formatBackground}`}
            role="img"
            title="bottomWaveBackground"
          />
        </div>

        {/* Content */}
        <Container className="py-sm col-start-1 row-start-1 grid size-full grid-cols-1 grid-rows-1 flex-col md:grid-cols-12 md:flex-row md:justify-around">
          <div className="col-span-full mb-4 md:col-span-8 md:mb-0">
            <Heading variant="lg" as="h2" className="mb-2 md:mb-9">
              Ad formats designed to engage
            </Heading>

            <div className="grid grid-cols-1 md:grid-cols-8">
              <div className="col-span-full md:col-span-4 md:mx-1.5">
                <div className="flex flex-col">
                  <Heading as="h3" className="mb-2 md:mb-4" variant="md">
                    Interstitial ads
                  </Heading>
                  <div className="flex">
                    <div className="text-clownfish">
                      <CheckFillCircleIcon size={19} />
                    </div>
                    <Text className="ml-2.5">
                      Video: Deliver powerful visual stories in fullscreen format, ensuring a
                      captivating user experience.
                    </Text>
                  </div>
                  <div className="flex">
                    <div className="text-clownfish">
                      <CheckFillCircleIcon size={19} />
                    </div>
                    <Text className="ml-2.5">
                      Still Image: Grab attention with high-definition, full-screen visuals that
                      resonate with our user&apos;s passion for the outdoors.
                    </Text>
                  </div>
                </div>
              </div>
              <div className="col-span-full md:col-span-3 md:col-start-5 md:mx-1.5">
                <div className="flex flex-col">
                  <Heading as="h3" className="mb-2 md:mb-4" variant="md">
                    Feed ads
                  </Heading>
                  <div className="flex">
                    <div className="text-clownfish">
                      <CheckFillCircleIcon size={19} />
                    </div>
                    <Text className="ml-2.5">
                      Integrate seamlessly into user feeds, blending your message with our rich
                      content for a natural and engaging user experience.
                    </Text>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="relative col-span-full justify-end md:col-span-4 md:col-start-9">
            <NextImage
              alt="Advertise format image"
              src={format}
              className="size-full object-cover sm:object-contain"
            />
          </div>
        </Container>
      </div>
    </section>
  );
};
